// `…/candidate/profile/more` — the CV viewer, transcluded into the snippet's own view.
//
// The parent decides whether this renders at all: `isInViewMoreState()` is a params comparison,
// not a path test, and it is false without an `algoScore` in the URL. See `CandidateProfile`.
import { type ReactElement } from 'react'
import { useSearchParams } from 'react-router-dom'
import { ExtensionViewWidth } from '@woo-ext/protocol'
import { CandidateResume } from '@woo-ext/ui'

export function CandidateResumeRoute(): ReactElement {
  const [params] = useSearchParams()

  const rawCandidateId = params.get('candidateId')
  const candidateId = rawCandidateId === null ? Number.NaN : Number.parseInt(rawCandidateId, 10)
  const rawAlertId = params.get('alertId')
  const alertId = rawAlertId === null ? Number.NaN : Number.parseInt(rawAlertId, 10)

  return (
    <CandidateResume
      {...(Number.isNaN(candidateId) ? {} : { candidateId })}
      {...(Number.isNaN(alertId) ? {} : { alertId })}
      // `ExtensionViewWidth.Detailed` — the More state's own `maxWidth`, on the element.
      flexBasis={ExtensionViewWidth.Detailed}
    />
  )
}
